/**
 * What each session recorder has told us about itself.
 *
 * These are readiness facts, not analytics data: both SDKs come up asynchronously from outside the
 * application bundle, and the cross-link between them cannot be written until both have a session.
 * Holding that in the store rather than in effect fields makes the wait durable — an effect that
 * subscribes after a recorder announced itself still sees it — and inspectable in the devtools.
 */
export interface AnalyticsSessionState {
  /** Null until RUM is initialized and has started a session. */
  rumSessionId: string | null;
  /** Replay URL, which changes each time FullStory starts a new session. */
  fullStorySessionUrl: string | null;
}

export const initialAnalyticsSessionState: AnalyticsSessionState = {
  rumSessionId: null,
  fullStorySessionUrl: null,
};
